import { render, staticRenderFns } from "./ClosedJobsPreview.vue?vue&type=template&id=48e760c5&"
import script from "./ClosedJobsPreview.vue?vue&type=script&lang=js&"
export * from "./ClosedJobsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports